import React, { useCallback, useEffect, useRef, useState } from "react";
import { PiUserCircle } from "react-icons/pi";

import { useGetCompanyLogoQuery, useUpdateCompanyLogoMutation } from "../../../features/api/customers";
import usePresignedPost from "../../../hooks/usePresignedPost";
import useUpload from "../../../hooks/useUpload";

function useCompanyLogo() {
  const { data } = useGetCompanyLogoQuery();
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (data?.url) {
      setUrl(data.url);
    }

    return () => {
      setUrl(null);
    };
  }, [data]);

  return { url };
}

export default function CompanyLogo() {
  const [selectedFile, setSelectedFile] = useState(null);
  const { url } = useCompanyLogo();
  const { presignedPostData } = usePresignedPost(selectedFile);
  const { uploadDone } = useUpload(presignedPostData, selectedFile);
  const updateCompanyLogo = useUpdateCompanyLogoMutation()[0];
  const fileInputRef = useRef();
  const handleFileChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (file) {
        setSelectedFile(file);
      }
    },
    [setSelectedFile],
  );

  useEffect(() => {
    if (uploadDone) {
      updateCompanyLogo({ fileKey: presignedPostData.fields.key });
    }
  }, [uploadDone, updateCompanyLogo, presignedPostData]);

  return (
    <div>
      <h3 className="mb-4">Company Logo</h3>
      <div className="d-flex flex-column flex-lg-row align-items-center gap-4">
        <div style={{ width: "6rem" }}>{url ? <img width="100px" src={url} alt="Company logo" /> : <PiUserCircle size={80} />}</div>

        <div style={{ width: "14rem" }} className="d-flex flex-column gap-2 justify-content-center">
          <button onClick={() => fileInputRef.current.click()} disabled={false} style={{ width: "7rem" }} type="button" className="btn btn-secondary fw-bold">
            Upload
          </button>
          <input ref={fileInputRef} onChange={handleFileChange} type="file" className="d-none" />
          <p className="text-muted m-0">Upload images up to 256x256 and 4mb in size.</p>
        </div>
      </div>
    </div>
  );
}
